// fallback evaluations
var DEFAULT_EVALUATIONS = {
  dynamicConfigs: {},
  experiments: {},
  gates: {}
};
// fallback config evaluation
var DEFAULT_CONFIG = {
  groupId: '',
  value: {}
};
// fallback gate evaluation
var DEFAULT_GATE = {
  groupId: '',
  value: false
};

export { DEFAULT_CONFIG, DEFAULT_EVALUATIONS, DEFAULT_GATE };
//# sourceMappingURL=index.js.map
